import { JobVehicleRentClass } from '~/shared';

export const menuTabsClassOrder = [
	JobVehicleRentClass.Economy,
	JobVehicleRentClass.Comfort,
	JobVehicleRentClass.Business,
	JobVehicleRentClass.Luxury,
];

export const menuTabsClassNames: { [key in JobVehicleRentClass]: string } = {
	[JobVehicleRentClass.Economy]: 'Эконом',
	[JobVehicleRentClass.Comfort]: 'Комфорт',
	[JobVehicleRentClass.Business]: 'Бизнес',
	[JobVehicleRentClass.Luxury]: 'Люкс',
};
